const SET_LOADER = 'SET_LOADER';

export {
  SET_LOADER
};

